export { DisclosurePage as default } from '@/components/enpages/Ir/Manage/Disclosure'
